// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
import { getAuth } from "firebase/auth"

const {
  REACT_APP_APIKEY,
  REACT_APP_AUTHDOMAIN,
  REACT_APP_PROJECTID,
  REACT_APP_STORAGEBUCKET,
  REACT_APP_MESSAGINGSENDERID,
  REACT_APPID
} = process.env

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQzeFLylGNez7zRdn3diV3NB89Ha12-hw",
  authDomain: "rita-translation-6d0c5.firebaseapp.com",
  projectId: "rita-translation-6d0c5",
  storageBucket: "rita-translation-6d0c5.appspot.com",
  messagingSenderId: "664575908983",
  appId: "1:664575908983:web:f8e1ae2b14fd06cade7a72"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize database
const db = getFirestore(app)

// Initialize storage
const storage = getStorage(app)

// Initialize storage
const auth = getAuth(app)

export { app, db, storage }